module.exports = __webpack_public_path__ + "img/logo-designed.2ec1733a.jpg";